<ng-container *ngIf="isResultsPage; else searchBarMobile">
  <app-swipe-up
    [classType]="swipeStyle"
    [height]="100"
    [title]="'TITLE_SEARCH_HOME' | transloco"
    [showHeader]="true"
    [showSwipeUp]="editSearchIsActivated$ | async"
    (toggleShowSwipeUp)="toggleSearchBar()">
    <ng-container *ngIf="editSearchIsActivated$ | async" content>
      <ng-container *ngTemplateOutlet="searchBarMobile"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #searchBarMobile>
  <div class="search-bar-mobile"
    [class.results]="isResultsPage"
    [class.is-detail]="showHotelDetail"
    [class.no-flight-controls]="(showFlightControls$ | async) === false">
    <div class="scrolling">
      <ng-container *ngIf="!showHotelDetail">
        <app-packages-destination-mobile
          [isSubmited]="isSubmitted"
          [isOneWayTrip]="isOneWayTrip$ | async"
          [searchType]="searchType"
          [isVertSwipe]="true"
          [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
          [cityAndAirportsPlaces]="autoCompletePlaces$ | async | autocompleteVm"
          [hotelOrLocationPlaces]="hotelAutoCompletePlaces$ | async"
          [destinationPlace]="packagesDestinationPlace$ | async"
          [departurePlace]="packagesOriginPlace$ | async"
          (selectPackagesDestination)="selectPackagesDestination($event)"
          (selectPackagesDeparture)="selectPackagesDeparture($event)"
          (popularAmplitudeEvent)="popularSelectedEvent($event)"
          (runAutocomplete)="runAutocomplete($event)"
          (resetAutocomplete)="resetAutocomplete()"
          (swipeAction)="swipeAction()">
        </app-packages-destination-mobile>
      </ng-container>
      <div class="travel-calendar-input-cont">
        <app-search-bar-input
          [showError]="isEmptyDepartureDate$ | async"
          [label]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_DEPARTURE' | transloco"
          [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_DEPARTURE' | transloco"
          [value]="departureDate$ | async | flightDate"
          [icon]="icons.Calendar"
          (isFocus)="showMobileCalendar(calendarField.departure)"
          [readOnly]="true"
          [isMobile]="true"
          [swapPlaceholder]="true">
        </app-search-bar-input>
        <app-search-bar-input
          [showError]="isEmptyArrivalDate$ | async"
          [label]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_RETURN' | transloco"
          [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_RETURN' | transloco"
          [value]="arrivalDate$ | async | flightDate"
          [icon]="icons.Calendar"
          [disabled]="isOneWayTrip$ | async"
          (isFocus)="showMobileCalendar(calendarField.arrival)"
          [readOnly]="true"
          [isMobile]="true"
          [swapPlaceholder]="true">
        </app-search-bar-input>
      </div>
      <div class="travel-destination-cont">
        <app-search-bar-room
          #hotelRoomsSelectorRef
          [icon]="icons.ChevronFilledDown"
          [id]="'search-bar-hotel-room'"
          [label]="'HOTELS_MODULE.HOME.ROOMS_LABEL' | transloco"
          [placeholder]="'HOTELS_MODULE.HOME.ROOMS_PLACEHOLDER' | transloco"
          [control]="roomControl"
          [searchType]="searchType"
          [isMobile]="true"
          [intialRooms]="rooms"
          [searchBy]="searchBy"
          (fetchMessageAction)="fetchMessageAction()"
          (setGuestsPerRoom)="setGuestsPerRoom($event)"
          (addNewRoom)="addRoom($event)"
          (removeRoom)="removeRoom($event)"
          (emitRoomsSelection)="roomsPackageSelection($event)">
        </app-search-bar-room>
      </div>
    </div>
    <app-fixed-surface
      [boxShadow]="true">
      <app-ds-button
        [isLoading]="searching"
        [labels]="{ ButtonLabel: 'BUTTONS.SEARCH' | transloco }"
        (clickEvent)="searchPackages()">
      </app-ds-button>
    </app-fixed-surface>
  </div>
</ng-template>

